import React from "react";
import AliancesSection from "../../components/AboutUs/Alliances/AliancessSection.tsx";
import MetaComponent from "../../components/CommonComponents/MetaComponent.tsx";

const Alliances: React.FC = () => {
  return (
    <div>
       <MetaComponent
        title="Alliances of Aptech | Aptech Limited"
        desc="Explore Aptech's global alliances with top universities like Middlesex, Lincoln, and Bolton to unlock international degree and career opportunities. "
        keywords="vocational training institute, skill enhancement training, aptech alliances"
      />
      <AliancesSection />
    </div>
  );
}

export default Alliances;
